import { imageNames } from "@/src/constants/imageConstants.js";

export const statuses = {
  TODO: "Todo",
  DONE: "Done",
};

export const statusProvider = {
  Draft: ["Draft", "default"],
  Active: ["Active", "active"],
  Failed: ["Failed", "failed"],
  "In Progress": ["In Progress", "in_progress"],
  Paused: ["Paused", "paused"],
  "In Active": ["In Active", "in_active"],
  Inactive: ["Inactive", "in_active"],
  Complete: ["Completed", "complete"],
  Completed: ["Completed", "complete"],
  Cancelled: ["Cancelled", "cancelled"],
  Todo: ["Todo", "todo"],
  Done: ["Completed", "done"],
  Ended: ["Stopped", "ended"],
  "Insufficient Credits": ["Paused", "paused"],
  Verified: ["Verified", "complete"],
  Pending: ["Pending", "in_progress"],
  Unverified: ["Unverified", "paused"],
  Invalid: ["Invalid", "cancelled"],
  Scheduled: ["Scheduled", "scheduled"],
  "Scheduled Processing": ["Scheduled Processing", "in_progress"],
  Sent: ["Sent", "sent"],
  Connected: ["Connected", "active"],
  Disconnected: ["Disconnected", "in_active"],
  connected: ["Connected", "active"],
  disconnected: ["Disconnected", "cancelled"],
  Duplicate: ["Duplicate", "cancelled"],
  Retrying: ["Retrying", "in_progress"],
  Bounced: ["Bounced", "bounced"],
  Skipped: ["Skipped", "skipped"],
  "Not Sent": ["Not Sent", "not_sent"],
  Opened: ["Opened", "opened"],
  Delivered: ["Delivered", "delivered"],
  Clicked: ["Clicked", "clicked"],
  Replied: ["Replied", "replied"],
  Approved: ["Approved", "complete"],
  Rejected: ["Rejected", "cancelled"],
  "Under review": ["Under Review", "in_progress"],
  Open: ["Open", "active"],
  Merged: ["Merged", "merged"],
  Closed: ["Closed", "failed"],
  Unsubscribed: ["Unsubscribed", "unsubscribed"],
};

export const statusCSSProvider = {
  IN_ACTIVE: ["Inactive", "paused"],
  ACTIVE: ["Active", "active"],
  IN_PROGRESS: ["In Progress", "in_progress"],
  PAUSED: ["Paused", "paused"],
  COMPLETE: ["Completed", "complete"],
  CANCELLED: ["Cancelled", "cancelled"],
  ENDED: ["Stopped", "ended"],
  INSUFFICIENT_CREDITS: ["Paused", "paused"],
  SCHEDULED: ["Scheduled", "scheduled"],
  SCHEDULED_PROCESSING: ["Scheduled Processing", "in_progress"],
  SENT: ["Sent", "sent"],
  FAILED: ["Failed", "failed"],
  DUPLICATE: ["Duplicate", "cancelled"],
  RETRYING: ["Retrying", "in_progress"],
  BOUNCED: ["Bounced", "bounced"],
  SKIPPED: ["Skipped", "skipped"],
  NOT_SENT: ["Not Sent", "not_sent"],
  OPENED: ["Opened", "opened"],
  DELIVERED: ["Delivered", "delivered"],
  CLICKED: ["Clicked", "clicked"],
  REPLIED: ["Replied", "replied"],
  UNSUBSCRIBED: ["Unsubscribed", "unsubscribed"],
};

export const outreachStatusProvider = {
  "Researching Company": ["Researching Company", "researching"],
  "Researching Contact": ["Researching Contact", "researching"],
  Paused: ["Paused", "paused"],
  Generating: ["Generating", "generating"],
  "To Review": ["To Review", "to_review"],
  "In Progress": ["In Progress", "in_progress"],
  "In Active": ["In Active", "in_active"],
  Inactive: ["Inactive", "in_active"],
  Active: ["Active", "active"],
  Pending: ["Pending", "default"],
  Complete: ["Completed", "complete"],
  Replied: ["Reply Received", "replied"],
  Ended: ["Stopped", "ended"],
  Removed: ["Removed", "removed"],
  Bounced: ["Bounced", "bounced"],
  Unsubscribed: ["Unsubscribed", "unsubscribed"],
  ReplyRecieved: ["Reply Recieved", "replyReceived"],
  Unqualified: ["Unqualified", "unqualified"],
  "Insufficient Credits": ["Paused", "paused"],
  Skipped: ["Skipped", "removed"],
  "Not Sent": ["Not Sent", "removed"],
};

export const outputStatusOptions = [
  { value: "RESEARCH", label: "Researching" },
  { value: "STEPS_GENERATION", label: "Generating" },
  { value: "PENDING_APPROVAL", label: "To-Review" },
  { value: "PAUSED", label: "Paused" },
  { value: "IN_PROGRESS", label: "In Progress" },
  { value: "COMPLETED", label: "Completed" },
  { value: "REPLIED", label: "Reply Received" },
  { value: "NOT_SENT", label: "Not Sent" },
  { value: "ENDED", label: "Stopped" },
  { value: "REMOVED", label: "Removed" },
  { value: "BOUNCED", label: "Bounced" },
  { value: "UNSUBSCRIBED", label: "Unsubscribed" },
];

export const healthStatusOptions = {
  GOOD: { label: "Good", icon: imageNames.GREEN_DOT },
  AVERAGE: { label: "Average", icon: imageNames.ORANGE_DOT },
  BAD: { label: "Bad", icon: imageNames.RED_DOT },
};

export const warmStatusOptions = {
  PENDING: "PENDING",
  CONNECTED: "CONNECTED",
  PAUSED: "PAUSED",
};

export const sequenceStatusOptions = [
  { value: "IN_PROGRESS", label: "Active" },
  { value: "PAUSED", label: "Paused" },
  { value: "COMPLETE", label: "Complete" },
  { value: "REPLIED", label: "Replied" },
  { value: "NOT_SENT", label: "Not Sent" },
  { value: "BOUNCED", label: "Bounced" },
  { value: "UNSUBSCRIBED", label: "Unsubscribed" },
  { value: "REMOVED", label: "Removed" },
  { value: "UNQUALIFIED", label: "Unqualified" },
];
